export default __webpack_public_path__ + "static/media/Developer.7376ca8c.svg";